<template>
    <div v-if="activeProduct.turnover_shops && activeProduct.turnover_shops.length > 0" class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="5">{{ "Turnover" | t }}</v-col>
            <v-col class="col-item" cols="5"> {{ activeProduct.turnover | rn }}€</v-col>
        </v-row>
        <v-divider class="my-2" />

        <div>
            <v-row>
                <v-col class="col-item row-title" cols="5">{{ "Shop name" | t }}</v-col>
                <v-col class="col-item row-title" cols="5"> {{ "Quantity" | t }}</v-col>
            </v-row>
            <v-row v-for="shop in activeProduct.turnover_shops" :key="shop[0]">
                <v-col class="col-item" cols="5">{{ shop[0] }}</v-col>
                <v-col class="col-item" cols="5"> {{ shop[1] }} {{ "pcs" | t }}</v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "quantity-tab",
    computed: {
        ...mapState("ProductStore", ["activeProduct"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
